import React from 'react';

interface Achievement {
    value: string;
    label: string;
}

interface AboutFounderProps {
    name: string;
    handle: string;
    avatar: string;
    bio: string;
    achievements: Achievement[];
    className?: string;
}

export const AboutFounder: React.FC<AboutFounderProps> = ({
    name,
    handle,
    avatar,
    bio,
    achievements,
    className = '',
}) => {
    return (
        <div className={`trader-about ${className}`}>
            <div className="trader-about-card">
                <img src={avatar} alt={name} className="trader-about-avatar" />

                <div className="trader-about-info">
                    <h3>{name}</h3>
                    <div className="trader-about-handle">{handle}</div>
                    <p className="trader-about-bio">{bio}</p>
                </div>

                <div className="trader-about-achievements">
                    {achievements.map((ach, index) => (
                        <div key={index} className="trader-about-achievement">
                            <div className="trader-about-achievement-value">{ach.value}</div>
                            <div className="trader-about-achievement-label">{ach.label}</div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default AboutFounder;
